import { render, staticRenderFns } from "./mainCom.vue?vue&type=template&id=571e8710&"
import script from "./mainCom.vue?vue&type=script&lang=js&"
export * from "./mainCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports